import { render, staticRenderFns } from "./syncWxRecord.vue?vue&type=template&id=3e2f7760&scoped=true"
import script from "./syncWxRecord.vue?vue&type=script&lang=js"
export * from "./syncWxRecord.vue?vue&type=script&lang=js"
import style0 from "./syncWxRecord.vue?vue&type=style&index=0&id=3e2f7760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f7760",
  null
  
)

export default component.exports